import { useMe } from '@crehana/web';
import {
  MembershipTypeMethod,
  UserDegreeSegmentationEnum,
} from '@crehana/web/__generated__/graphql-schema';

import { StudentTypeEnum } from '../../types';

const useGetStudentType = () => {
  const { me } = useMe();
  let studentType = StudentTypeEnum.PAYG;

  if (
    me?.userDegreeSegmentation ===
    UserDegreeSegmentationEnum.ACTIVATED_DEGREE_SEGMENTATION
  ) {
    studentType = StudentTypeEnum.DEGREE;
  } else if (me?.hasOrganization || me?.segmentation === 'B2B') {
    studentType = StudentTypeEnum.B2B;
  } else if (me?.isPremiumMember || me?.segmentation === 'Member') {
    if (me?.membership?.membershipType?.method === MembershipTypeMethod.A_2) {
      studentType = StudentTypeEnum.PREMIUM_TRIAL;
    } else {
      studentType = StudentTypeEnum.PREMIUM;
    }
  } else if (me?.segmentation === 'Register') {
    studentType = StudentTypeEnum.REGISTER;
  }

  return studentType;
};

export default useGetStudentType;
